import React, {useState} from 'react';

import {Asset, AssetGroup} from '@deviceinsight/ng-ui-api-client';
import {DataProcessingDefinition} from '../../../../api/dataProcessingDefinitionApi';
import {Button} from '@deviceinsight/ng-ui-basic-components';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import KpiSearchComponent from './components/kpi-table/KpiSearchComponent';
import SingleAssetSelectionTable from '../../../../modules/search/asset/SingleAssetSelectionTable';

type Props = {
	assetGroup: AssetGroup | null | undefined;
	onAssetSelect: (asset: Asset, index: number) => void;
	onKpiNameSelect: (kpiName: string | null | undefined, index: number) => void;
	children: (
		setAssetSelecting: (index: number) => void,
		setKpiNameSelecting: (index: number, assetUrn: string) => void
	) => React.ReactElement;
};

const ResourcesProvider = ({assetGroup, children, onAssetSelect, onKpiNameSelect}: Props) => {
	const [selectingAsset, setSelectingAsset] = useState(false);
	const [selectedAssetUrn, setSelectedAssetUrn] = useState<string | null | undefined>();
	const [selectingKpi, setSelectingKpi] = useState(false);
	const [currentIndex, setCurrentIndex] = useState<number>(0);

	if (selectingAsset) {
		return (
			<>
				<SingleAssetSelectionTable
					data-testid="asset-selection-table-wrapper"
					assetGroup={assetGroup ?? undefined}
					onSelectAsset={(asset) => {
						setSelectingAsset(false);
						setSelectingKpi(true);
						onAssetSelect(asset, currentIndex);
						setSelectedAssetUrn(asset.urn);
					}}
				/>
				<Button onClick={() => setSelectingAsset(false)}>
					<Trans i18nKey="general.page.back">Back</Trans>
				</Button>
			</>
		);
	} else if (selectedAssetUrn && selectingKpi) {
		return (
			<>
				<KpiSearchComponent
					data-testid="selecting-kpi-area"
					assetUrn={selectedAssetUrn}
					onKpiSelect={(dpd: DataProcessingDefinition) => {
						setSelectingKpi(false);
						onKpiNameSelect(dpd.definition?.kpiName, currentIndex);
					}}
				/>
				<Button onClick={() => setSelectingKpi(false)}>
					<Trans i18nKey="general.page.back">Back</Trans>
				</Button>
			</>
		);
	}

	return children(
		(index: number) => {
			setSelectingAsset(true);
			setCurrentIndex(index);
		},
		(index: number, assetUrn: string) => {
			setSelectedAssetUrn(assetUrn);
			setSelectingKpi(true);
			setCurrentIndex(index);
		}
	);
};

export default ResourcesProvider;
